import { Link } from "react-router-dom";
import LazyImage from "../components/ui/LazyImage";
import { getImageSrc } from "../utils/getImageSrc";
import logo from "../assets/images/green-logo.png";
import { toPersianDate } from "../utils/dateFormatter";
import { highlightText } from "../utils/TextHighLighter";

interface InstitutionCardProps {
  project: any;
  index: number;
  isActive: boolean;
  searchQuery: string;
  onClick: (index: number) => void;
}

export default function InstitutionCard({
  project,
  index,
  isActive,
  searchQuery,
  onClick,
}: InstitutionCardProps) {
  const projectLogo = getImageSrc(
    project.logo,
    project.cover,
    project.image,
    project.avatar,
    project.extra
  );

  return (
    <Link
      to={`/institutions/${project.id}`}
      onClick={() => onClick(index)}
      className={`xl:max-w-full h-[90px] border hover:border-complement-03 group gap-x-2.5 p-2.5 transition-all duration-300 cursor-pointer shadow-sm rounded-[20px] overflow-hidden min-w-0 ${
        isActive
          ? "bg-green-02 text-white shadow-lg border-green-04/15"
          : "bg-white text-green-05 hover:bg-green-02 group-hover:text-green-05 group-hover:border-green-02 group-hover:border"
      }`}
    >
      <div className="flex items-center justify-start gap-x-2.5 h-full mb-2">
        <div className="size-[70px] shrink-0 bg-white border border-green-02 rounded-[19px] overflow-hidden">
          <LazyImage
            src={projectLogo || logo}
            alt={project.name ?? ""}
            className="h-full w-full text-xs text-center object-contain"
          />
        </div>

        <div className="flex flex-col items-start justify-between w-full font-estedad min-w-0 space-y-[2.5px] overflow-hidden">
          <h5 className="text-[15px] font-bold text-green-05 w-full truncate">
            {highlightText(project.name ?? "", searchQuery)}
          </h5>
          {project.date_establishment && (
            <p className="text-[11px] font-medium text-green-04 w-full break-words">
              {toPersianDate(project.date_establishment)}
            </p>
          )}
        </div>
      </div>
    </Link>
  );
}